import { FEATURES } from '../../../common';
class BuildingsSideNav {
    constructor($sce, $window, $timeout, $rootScope, $templateCache, $scope) {
        this.restrict = 'E';
        this.$sce = $sce;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.selectedBuilding = null;
        this.buildingsForPaging = [];
        this.$templateCache = $templateCache;
        this.link = this.BuildingsSideNavLink;
        this.template = this.loadDirectiveTemplate;
        this.$scope = $scope;

        this.scope = {
            buildings: '=',
            selectedBuilding: '='
        };
    }

    get loadDirectiveTemplate() {
        const template = this.$templateCache.get(
            'nav-bar/side/buildings-side-nav-tmpl.html'
        );
        return template;
    }

    _registerEventHandling(element) {
        this.$timeout(() => {
            const selector = '.building a, .building a img, .building a span';
            const $links = angular.element(selector, this.scopeReference.$element);

            $links.each((i, ele) => {
                const $ele = angular.element(ele);
                $ele.on('click', evt => {
                    let link;
                    const { currentTarget } = evt;

                    if (currentTarget.tagName !== 'a') {
                        link = angular.element(currentTarget).closest('a')[0];
                    } else {
                        link = currentTarget;
                    }

                    const $link = angular.element(link);
                    const buildingName = $link.text().trim();
                    $("MainVM").context.all.selectedBuildingTitle.innerText = buildingName;

                    this.scopeReference.$parent.$parent.$broadcast(
                        'reload-user-units',
                        buildingName
                    );
                });
            });
        }, 1500);

        this.$rootScope.$watch('selectedBuilding', (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.scopeReference.selectedBuildingReference = newValue;
            }
        });
    }

    changeBuilding(buildingReference) {

        this.$parent.$emit('navigate-changed', FEATURES.DOCUMENTS);
        this.$timeout(() => {
            this.buildings = this._mapBuildings(this.buildings);

            for (let index = 0; index < this.buildings.length; index++) {
                const building = this.buildings[index];
                if (building.SchemeReference === buildingReference) {
                    building.isSelected = true;
                    this.title = building.SchemeName;
                } else {
                    building.isSelected = false;
                }
            }
            this.$parent.$emit('selected-building-changed', buildingReference);

        });
    }

    init(scope, element) {
        const { buildings, selectedBuilding } = scope;

        scope.$timeout = this.$timeout;
        scope._mapBuildings = this._mapBuildings;
        scope.changeBuilding = this.changeBuilding;
        scope.buildings = this._mapBuildings(buildings);

        this.scopeReference = scope;
        this.scopeReference.selectedBuildingReference = selectedBuilding;
        this.scopeReference.buildingsForPaging = this._mapBuildings(buildings);

        const $element = angular.element(element);
        this._registerEventHandling($element);
    }

    _mapBuildings(original) {
        if (!!!original || original.length === 0) {
            return null;
        }

        let mapped = original.map(building => {
            const { SchemeReference: schemeReference } = building;
            return {
                ...building,
                isSelected: false
            };
        });

        return mapped;
    }

    getTrustedBuildingImageUrl(schemeReference) {
        const imgUrl = this.$sce.trustAsResourceUrl(
            `${PretorCDNAddress}/images/buildings/${schemeReference}/${schemeReference}.png`
        );
        const trustedUrl = this.$sce.valueOf(imgUrl);
        return trustedUrl;
    };

    BuildingsSideNavLink(scope, element, attrs) {
        this.init(scope, element);
    }
}

export default /* @ngInject */ (
    $sce,
    $window,
    $timeout,
    $rootScope,
    $templateCache
) => new BuildingsSideNav($sce, $window, $timeout, $rootScope, $templateCache);
